import _ from 'lodash'
import { createSelector } from 'reselect'

// schedules
export const getSchedules = state => _.get(state, 'scheduleRepairActions.schedules.data', [])
export const getLoadingSchedules = state => _.get(state, 'scheduleRepairActions.loading', false)
export const getSelectedScheduleByIndex = state => selectedIndex =>
  createSelector([getSchedules], schedules => schedules[selectedIndex])(state)

// attachments
export const getScheduleRepairAttachments = state =>
  _.get(state, 'scheduleRepairActions.attachments', [])
export const getAttachmentsLoading = state =>
  _.get(state, 'scheduleRepairActions.loadingAttachments', false)
export const getAttachmentUploading = state =>
  _.get(state, 'scheduleRepairActions.uploadingAttachment', false)
export const getAttachmentDeleting = state =>
  _.get(state, 'scheduleRepairActions.deletingAttachment', false)

// notes
export const getScheduleRepairNotes = state => _.get(state, 'scheduleRepairActions.notes.data', [])



// WEBPACK FOOTER //
// ./src/selectors/scheduleRepair/scheduleRepair.js